<template>
  <div>
    <form
      id="group-form"
      @submit="checkForm"
      action="#"
      method="post"
      novalidate="true"
    >
      <div class="form-item">
        <label class="required" for="group-name">{{
          $t("group.groupEditForm.groupName")
        }}</label>
        <p v-if="errGroupName && groupName.length > 30" class="error">
          {{ $t("group.groupEditForm.errorMsg.groupName") }}
        </p>
        <p v-if="errSurrogatePair" class="error">
          {{ $t("group.groupEditForm.errorMsg.surrogatePair") }}
        </p>
        <input
          id="group-name"
          name="group-name"
          maxlength="30"
          v-model="groupName"
          v-on:input="updateForm = true"
          v-bind:class="{
            error: errGroupName || errSurrogatePair || invalidGroupName,
          }"
        />
        <p v-if="errGroupName" class="error errorMsg">
          {{ $t("group.groupEditForm.errorMsg.noGroupName") }}
        </p>
        <p v-if="invalidGroupName" class="error errorMsg">
          {{ $t("group.groupEditForm.errorMsg.invalidGroupName") }}
        </p>
        <span
          v-bind:class="{ 'char-count': true, error: groupName.length > 30 }"
        >
          {{ groupName.length }} / 30
        </span>
      </div>

      <div class="form-item">
        <label class="" for="group-summary">{{
          $t("group.groupEditForm.groupSummary")
        }}</label>
        <p v-if="errGroupSummary && groupSummary.length > 300" class="error">
          {{ $t("group.groupEditForm.errorMsg.groupSummary") }}
        </p>
        <textarea
          id="group-summary"
          name="group-summary"
          rows="4"
          maxlength="300"
          v-model="groupSummary"
          v-on:input="updateForm = true"
          v-bind:class="{ error: errGroupSummary }"
        ></textarea>
        <span
          v-bind:class="{
            'char-count': true,
            error: groupSummary.length > 300,
          }"
        >
          {{ groupSummary.length }} / 300
        </span>
      </div>

      <div
        v-if="
          user.userInfo &&
            (role === 'PlanOwner' || user.userInfo.userType === 1)
        "
        class="archive-wrapper"
      >
        <input
          type="checkbox"
          id="archive"
          v-model="groupArchived"
          v-on:input="updateForm = true"
        />
        <label for="archive">{{ $t("group.groupEditForm.archive") }}</label>
      </div>

      <input
        type="submit"
        class="submit"
        v-bind:value="$t('group.groupEditForm.button.save')"
      />
    </form>
    <Modal
      v-if="showModal"
      v-bind:modalTitle="$t('group.groupEditForm.modal.header')"
      @close="showModal = false"
    >
      <div class="confirm-modal">
        <p class="modal-text" v-html="$t('group.groupEditForm.modal.text')"></p>
        <a v-on:click.prevent="updateGroup" class="button" href="#">OK</a>
        <a
          v-on:click="showModal = false"
          class="button archive-cancel"
          href="#"
          >{{ $t("group.groupEditForm.button.cancel") }}</a
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";

import { validSurrogatePair } from "@/utils/validSurrogatePair";
import { validFileInclusion } from "@/utils/validFileInclusion";
import { groupService } from "@/services/group.service";
import { projectService } from "@/services/project.service";

export default {
  name: "GroupForm",
  components: {
    Modal,
  },
  data() {
    //let user = JSON.parse(localStorage.getItem('user'))
    return {
      groupId: 0,
      invalidForm: true,
      invalidGroupName: false,

      errGroupName: false,
      errSurrogatePair: false,
      errGroupSummary: false,

      groupName: "",
      groupSummary: "",
      groupArchived: false,
      initGroupArchived: false,

      user: {},
      role: "",

      showModal: false,
      onceProc: true,
    };
  },
  mounted: function() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.groupId = this.$route.params.groupId;

    this.fetchGroup();
  },
  methods: {
    fetchGroup: function() {
      // grab the group
      groupService.getGroup(this.groupId).then((group) => {
        this.groupName = group.name;
        if (group.description) {
          this.groupSummary = decodeURIComponent(atob(group.description));
        }
        this.groupArchived = !group.enabled;
        this.initGroupArchived = !group.enabled;
        this.role = group.role;
      });
    },
    checkForm: function(event) {
      this.invalidForm = false;
      this.errGroupName = false;
      this.errSurrogatePair = false;
      this.errGroupSummary = false;

      if (this.groupName === "") {
        this.invalidForm = true;
        this.errGroupName = true;
      }

      if (this.groupName.length > 30 || validFileInclusion(this.groupName)) {
        this.invalidForm = true;
        this.invalidGroupName = true;
      }

      if (validSurrogatePair(this.groupName)) {
        this.invalidForm = true;
        this.errSurrogatePair = true;
      }

      if (this.groupSummary.length > 300) {
        this.invalidForm = true;
        this.errGroupSummary = true;
      }

      if (!this.invalidForm) {
        if (this.groupArchived) {
          this.showModal = true;
        } else {
          this.updateGroup();
        }
      }

      event.preventDefault();
    },
    updateGroup: function() {
      let group = {
        description: btoa(encodeURIComponent(this.groupSummary)),
        name: this.groupName,
        enabled: !this.groupArchived,
      };

      groupService
        .updateGroup(this.groupId, group)
        .then(() => {
          // check to change Archive checkbox
          if (this.initGroupArchived != this.groupArchived) {
            this.getProjects();
          } else {
            this.confirmArchive();
          }
        })
        .catch((err) => {
          console.error("Something went wrong: ", err);
        });
    },
    getProjects: function() {
      groupService
        .getProjects(this.groupId)
        .then((projects) => {
          for (let project of projects) {
            this.updateProject(project);
          }
        })
        .catch((err) => {
          console.error("Something went wrong: ", err);
        });
    },
    updateProject: function(project) {
      let modProject = {
        description: project.description,
        name: project.name,
        enabled: !this.groupArchived,
      };

      projectService
        .updateProject(project.id, modProject)
        .then(() => {
          if (this.onceProc) {
            this.confirmArchive();
            this.onceProc = false;
          }
        })
        .catch((err) => {
          console.error("Something went wrong updating project: ", err);
        });
    },
    confirmArchive: function() {
      this.showModal = false;
      this.$router.push("/group/" + this.groupId);
    },
  },
};
</script>
<style lang="scss">
.modal-body {
  color: $text-dark;
  padding: 40px 40px 0;

  #group-form {
    padding: 20px 0;
  }
}

#group-form {
  max-width: 528px;

  .form-item {
    position: relative;
    .char-count {
      position: absolute;
      right: 0;
      bottom: 5px;
    }
  }

  .archive-wrapper {
    margin-bottom: 25px;

    label {
      display: inline;
    }
  }

  input.submit {
    @extend button;
    margin-top: 0;
    width: auto;
  }
  .auth-req {
    margin-top: 15px;
    padding-top: 30px;
    border-top: 2px solid #ccc;
  }
}

.confirm-modal {
  padding: 0 0 25px 0;
}

.modal-text {
  font-weight: bold;
}

.archive-cancel {
  margin-left: 50px;
}
</style>
